import { render, staticRenderFns } from "./SkinsChampionsSearch.vue?vue&type=template&id=71c292df&scoped=true&"
import script from "./SkinsChampionsSearch.vue?vue&type=script&lang=js&"
export * from "./SkinsChampionsSearch.vue?vue&type=script&lang=js&"
import style0 from "./SkinsChampionsSearch.vue?vue&type=style&index=0&id=71c292df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c292df",
  null
  
)

export default component.exports